// extracted by mini-css-extract-plugin
export var icons = "Icons-module--icons--vfYAc";
export var thumbicon = "Icons-module--thumbicon--K3uXK";
export var animateHeart = "Icons-module--animate-heart--3fj7q";
export var hearticon = "Icons-module--hearticon--ZCc21";
export var staricon = "Icons-module--staricon--2KwdB";
export var arrowicon = "Icons-module--arrowicon--1JZaf";